import ModalStocksAnalysis from 'components/Modal/ModalStocksAnalysis';
import { useDispatch, useSelector } from 'react-redux';

import ChartSolidgauge from 'components/StockAnalysis/components/DSCReviews/ChartSolidgauge';
import { formatMoney } from 'Helpers/helpFunction';
import useChart from 'hook/useChart';
import './InvestmentPortfolioRight.scss';
import FooterPortfolio from './InvestmentPortfolioRight/FooterPortfolio';


export default function InvestmentPortfolioRight() {
  const { makePrice } = useChart();
  const StocksAnalysisStore = useSelector((state) => state?.StocksAnalysisStore)
  const CompanyStore = useSelector((state) => state?.CompanyStore)
  const ChartStore = useSelector((state) => state?.ChartStore)
  const objectCompany = CompanyStore?.allCompany.filter((item) => {
    return item?.code === StocksAnalysisStore?.inputSearch ? item?.organname : ''
  })
  const companyName = objectCompany?.[0]?.organname || ''

  const ceiling = ChartStore?.stockInformation?.ceiling ? ChartStore?.stockInformation?.ceiling / 1000 : 0 //gia tran
  const floor = ChartStore?.stockInformation?.floor ? ChartStore?.stockInformation?.floor / 1000 : 0 // gia san
  const reference = ChartStore?.stockInformation?.reference ? ChartStore?.stockInformation?.reference / 1000 : 0 // gia san
  let volumn = 0
  let priceOpen = 0
  let priceClose = 0
  let PriceVolatility = 0 // gia chenh lech
  let PercentPriceVolatility = 0 // phan tram chenh lech

  if (StocksAnalysisStore?.inputSearch) {
    volumn = StocksAnalysisStore?.priceStockAnalysis[StocksAnalysisStore?.inputSearch]?.volumn
    priceOpen = StocksAnalysisStore?.priceStockAnalysis[StocksAnalysisStore?.inputSearch]?.priceOpen
    priceClose = StocksAnalysisStore?.priceStockAnalysis[StocksAnalysisStore?.inputSearch]?.priceClose
    PriceVolatility = makePrice(reference, priceClose).PriceVolatility
    PercentPriceVolatility = makePrice(reference, priceClose).PercentPriceVolatility
  }

  return (
    <>
      <div className='pwktivxzhn'>
        <div className='twqkflbtiz'>
          <div className='lzdvdsnoez'>
            <div className='ujwsqkwamf'>
              <div className='pdyrvcndkl'>{StocksAnalysisStore?.inputSearch}</div>
              <div className='uwawqeofpc'>{companyName}</div>
            </div>
            <div className='bnzmhgkohj'>
              <div className='zcdqxlqvfq' style={{ color: (PriceVolatility) ? (PriceVolatility < 0 ? '#e31e4d' : '#2ad03d') : '#ffffff' }}>
                {priceClose ? formatMoney(priceClose.toString(), 2) : '--'}
              </div>
              <div className='lnsflpoihp'>
                <div className='tppkiemkcd'>Biến động giá</div>
                <div className='safwpfhktt' style={{
                  color: PriceVolatility ? (PriceVolatility < 0 ? '#e31e4d' : '#2ad03d') : '#ffffff'
                }}>
                  {PriceVolatility ? PriceVolatility.toFixed(2) : '0'}({(PercentPriceVolatility > 0) ? `+${PercentPriceVolatility ? PercentPriceVolatility.toFixed(2) : ''}` :
                    `${PercentPriceVolatility ? PercentPriceVolatility.toFixed(2) : '0'}`}%)
                </div>
              </div>
              <div className='lrxznmxsoc'>
                <div className='wahlznjegt'>Khối lượng giao dịch</div>
                <div className='oabiygqfat'>{volumn ? formatMoney(volumn.toString()) : '--'}</div>
              </div>
            </div>
          </div>
          <div className='dpwkgezfhv'>
            <div className='kqqgddeobk'>DSC đánh giá</div>
            <div className='vblbdgvhtc'>
              <ChartSolidgauge />
            </div>
          </div>
        </div>
        <FooterPortfolio />
      </div>
      <ModalStocksAnalysis />
    </>
  )
}